import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ backgroundColor: '#1a1a1a', color: '#fff', padding: '40px 20px', marginTop: '60px', textAlign: 'center' }}>
      <div style={{ maxWidth: '1000px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <h3 style={{ margin: 0, letterSpacing: '1px' }}>Nundinaria</h3>
        <p style={{ color: '#aaa', fontSize: '14px', margin: 0 }}>The trusted marketplace for used gear.</p>
        
        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '10px', flexWrap: 'wrap' }}>
          {/* These links satisfy the Stripe/PayPal compliance bots */}
          <Link to="/terms" style={{ color: '#007bff', textDecoration: 'none', fontSize: '14px' }}>Terms of Service</Link>
          <Link to="/privacy" style={{ color: '#007bff', textDecoration: 'none', fontSize: '14px' }}>Privacy Policy</Link>
          <Link to="/refunds" style={{ color: '#007bff', textDecoration: 'none', fontSize: '14px' }}>Refund Policy</Link>
        </div>
        
        <p style={{ color: '#666', fontSize: '12px', marginTop: '20px' }}>
          &copy; {new Date().getFullYear()} Nundinaria. All rights reserved. <br/>
          Payments processed securely via Stripe and PayPal.
        </p>
      </div>
    </footer>
  );
}